<template>
  <div class="FieldError">
    {{ localeStrings.errorMessages[error] }}
  </div>
</template>

<script>
import strings from '../../data/strings.json'

export default {
  inject: ['locale'],
  props: {
    error: String,
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    },
  },
}
</script>

<style scoped>
.FieldError {
  color: var(--field-error-color, red);
}
</style>
